module.exports = "pegasus/assets/theme3/twitter-icon.png";